<template>
  <section
    id="output"
    class="co-bg-striped py-20 md:py-12"
  >
    <div class="co-container-lg mx-auto grid grid-cols-1 items-center px-0 sm:px-20 md:grid-cols-2 md:px-0">
      <div class="px-4">
        <h2 class="te-webdesing-output-h2 mb-4 text-center font-bold">
          ここまで作れるようになる
        </h2>
        <div class="co-display-12 mb-10 text-center leading-loose text-co-gray-600">
          受講中に作れるようになるデザイン成果物の一部をご紹介します。
        </div>
        <div class="mb-7 flex justify-center md:justify-center">
          <div class="flex w-full xl:w-4/5">
            <div class="mr-5 text-center">
              <img
                src="~/assets/images/Te/TeCourse/Webdesign/Output/icon-banner.svg"
                alt="アイコン"
                width="32"
                height="32"
                loading="lazy"
              >
            </div>
            <div class="text-left">
              <h4 class="co-display-10 font-bold">
                バナーデザイン
              </h4>
              <p class="mb-0">
                レイアウト、配色など、デザインを基礎から習得
              </p>
            </div>
          </div>
        </div>
        <div class="mb-7 flex justify-center md:justify-center">
          <div class="flex w-full xl:w-4/5">
            <div class="mr-5 text-center">
              <img
                src="~/assets/images/Te/TeCourse/Webdesign/Output/icon-bakery.svg"
                alt="アイコン"
                width="32"
                height="32"
                loading="lazy"
              >
            </div>
            <div class="text-left">
              <h4 class="co-display-10 font-bold">
                架空のベーカリーサイト
              </h4>
              <p class="mb-0">
                おしゃれなあしらいを施したサイトデザインの実践
              </p>
            </div>
          </div>
        </div>
        <div class="mb-7 flex justify-center md:justify-center">
          <div class="flex w-full xl:w-4/5">
            <div class="mr-5 text-center">
              <img
                src="~/assets/images/Te/TeCourse/Webdesign/Output/icon-site-map.svg"
                alt="アイコン"
                width="32"
                height="32"
                loading="lazy"
              >
            </div>
            <div class="text-left">
              <h4 class="co-display-10 font-bold">
                Webサイト構築
              </h4>
              <p class="mb-0">
                デザインを元にサイトを構築するコーディングの習得
              </p>
            </div>
          </div>
        </div>
        <div class="mb-7 flex justify-center md:mb-0 md:justify-center">
          <div class="flex w-full xl:w-4/5">
            <div class="mr-5 text-center">
              <img
                src="~/assets/images/Te/TeCourse/Webdesign/Output/icon-portfolio.svg"
                alt="アイコン"
                width="32"
                height="32"
                loading="lazy"
              >
            </div>
            <div class="text-left">
              <h4 class="co-display-10 font-bold">
                オリジナルポートフォリオサイト
              </h4>
              <p class="mb-0">
                オリジナルデザインのサイトをWeb上に公開
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="px-4 md:order-first">
        <img
          class="w-full"
          src="~/assets/images/Te/TeCourse/Webdesign/Output/output-webdesign.png"
          alt="制作物例"
          loading="lazy"
        >
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-webdesing-output-h2 {
  font-size: 1.5rem;
  line-height: 1.5;
  @media (min-width: 992px) {
    font-size: 2.25rem;
  }
}
</style>
